import { formatDate } from '@angular/common'

/**
 * Format:
 * YYYY-MM-DDThh:mm[:ss[.uuuuuu]][+HH:MM|-HH:MM|Z]
 */
export const formatDateTimeTz = (target: string) => {
  if (!target) return null
  return formatDate(target, 'yyyy-MM-ddTHH:mm:ssZ', 'en-US')
}
